export enum DeviceFamilyType {
  iphone,
  ipad,
  universal,
  unSupported,
}

export enum OwnerType {
  user,
  organization,
}
